import { connect } from 'react-redux'

import { conversationsResolvedPerDayGauge } from 'ducks/reports/gauges'
import { HeadlineVisualization } from 'ducks/reports/visualizations'

const staticProps = {
  gauges: [conversationsResolvedPerDayGauge],
}
export default function ConversationsResolvedPerDayHeadline(props) {
  return <HeadlineVisualization {...props} {...staticProps} />
}
